import AppliedFromTag from './AppliedFromTag';
const DICT = {
    'preview.applied_from.company_default': 'Company Default',
    'preview.applied_from.account': 'Account',
    'preview.applied_from.account_tag': 'Account Tag',
    'preview.applied_from.building': 'Building',
    'preview.applied_from.building_tag': 'Building Tag'
};
const t = (key) => { var _a; return (_a = DICT[key]) !== null && _a !== void 0 ? _a : key; };
const meta = {
    title: 'Features/Settings/TenantKnowledgeBase/AppliedFromTag',
    component: AppliedFromTag,
    parameters: {
        layout: 'padded'
    },
    args: {
        t
    }
};
export default meta;
/**
 * Tenant-level provenance — the "Company Default" chip.
 */
export const CompanyDefault = {
    args: {
        scope: 'tenant'
    }
};
/**
 * Building-level provenance chip.
 */
export const Building = {
    args: {
        scope: 'building'
    }
};
/**
 * Account-tag provenance chip.
 */
export const AccountTag = {
    args: {
        scope: 'account_tag'
    }
};
